import FeaturesContent from './FeaturesContent'

export default FeaturesContent
